import { useEffect, useRef } from "react";

import { subscribeBasketSubmissions } from "./basket-submission-events";
import type { BasketSubmissionListener } from "./types";

/**
 * Call `handler` once for every `/resources/basket` submission that settles
 * while the calling component is mounted — independent of which component owns
 * the fetcher and of whether the submission triggers any loader revalidation
 * (COM-830; see `basket-submission-events.ts`).
 *
 * `handler` lives in a ref, so it always sees the latest render's values and
 * call sites can pass inline closures without resubscribing.
 */
export function useBasketSubmissionSettled(
  handler: BasketSubmissionListener,
): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  useEffect(
    () => subscribeBasketSubmissions(result => handlerRef.current(result)),
    [],
  );
}
